import type { Language } from "@app/constants";

interface Messages {
	header: string;
	body: string;
	proceed: string;
}

type Message = {
	[key in Language]: Messages;
};

const messages: Message = {
	en: {
		header: "Note",
		body: `<p>You are about to add another client to your user account. This will allow you to manage their investment with Future Forex and therefore they will be required to sign a mandate giving you this permission.</p>
        <br/>
        <p>When a client you refer completes their first cycle with us, you’ll earn a <b>R750 referral reward</b>. Clients added to your user account are automatically considered as referred by you.</p>
        <br/>
        <p>Would you like to proceed?</p>`,
		proceed: "PROCEED",
	},
};

export default messages;
